import { toast } from "react-toastify";

const styles = {
  default: {
    fontSize: 16,
    color: "#2196f3",
  },
  info: {
    fontSize: 16,
    background: "#3498db",
    color: "#edf4f9",
  },
  success: {
    fontSize: 16,
    background: "#0c7c59",
    color: "#e8f3ef",
  },
  error: {
    fontSize: 16,
    background: "#e44240",
    color: "#fdebeb",
  },
  warning: {
    fontSize: 16,
    background: "#fff07c",
    color: "#746e39",
  },
};

export const sendMessage = (message, type = "success", props = {}) => {
  toast[type](message, {
    position: "top-right",
    style: styles[type],
    icon: false,
    ...props,
  });
};

export const sendError = (message) => sendMessage(message, "error");
